import { Button, Col, Row, Space, Table } from "antd";
import { ExpandSearch, InputFields, Notification } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { ExcelSVG, EyeWhiteSVG } from "assets";
import { detailReportAllColums, detailStoreFields } from "./config";
import {
  exportFile,
  formatDateToString,
  formatToCurrencyType,
} from "helper/common";
import { useAppSelector } from "redux/hooks";
import accoutingFinancial from "api/accoutingFinancial";
import moment from "moment";
import { FORMAT_TIME } from "types/enums";

const DetailReport = () => {
  const expandRef = useRef<any>();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  const [data, setData] = useState([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    start: dayjs(),
    end: dayjs(),
  });
  const activeTab = useAppSelector((e) => e.common.activeTab);

  const onChangePagination = (page: number, pageSize: number) => {
    setParams({ ...params, page: page, limit: pageSize });
  };
  const onClickSearchButton = async () => {
    try {
      const searchFields = await expandRef.current?.getData();
      setParams({
        ...params,
        ...searchFields,
        page: 1,
      });
    } catch (error) {
      Notification("warning", "Vui lòng nhập đủ thông tin");
    }
  };
  const formatParams = () => {
    return {
      ...params,
      start: formatDateToString(params.start),
      end: formatDateToString(params.end),
    };
  };
  const getList = async () => {
    setLoading(true);
    try {
      const res = await accoutingFinancial.getDetailStore(formatParams());
      const newData = res.map((item) => {
        return { ...item, key: item.id };
      });
      setData(newData);
      setTotal(res.total);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };
  useEffect(() => {
    getList();
  }, [params, activeTab]);

  detailReportAllColums.find((e) => e.dataIndex === "stt").render = (v, r, i) =>
    (params.page - 1) * params.limit + i + 1;
  const onKeyDown = (e) => {
    if (e.key == "Enter") {
      onClickSearchButton();
    }
  };
  const getReportFile = async () => {
    const param = formatParams();

    if (param?.start != null || param.end !== null) {
      exportFile(
        "/store/tckt/export-kho-chi-tiet",
        formatParams(),
        `Báo cáo kho - sổ chi tiết`
      );
    } else {
      Notification("warning", "Chưa chọn ngày để xuất báo cáo");
    }
  };
  const getStore = async () => {
    try {
      const params = {
        page: 1,
        limit: 1000,
        isKhoAo: false,
      };
      const res = await accoutingFinancial.getStore(params);

      const options = res.map((e) => {
        return {
          value: e.id,
          label:
            (e.nhomKho === "TH" && `[THUOC] ${e.name}`) ||
            (e.nhomKho === "KI" && `[KINH] ${e.name}`) ||
            (e.nhomKho === "VT" && `[VTYT] ${e.name}`),
        };
      });
      detailStoreFields.find((e) => e.name === "khoNhapId").options = options;
      detailStoreFields.find((e) => e.name === "khoXuatId").options = options;
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu kho");
    }
  };
  useEffect(() => {
    getStore();
  }, []);
  return (
    <div className="revenues-item">
      <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={detailStoreFields}
            initialValues={params}
            isExportExcel={true}
            isSearchExpend={false}
            isSearch={false}
            isResetField={false}
            isShowDetail={true}
            handleExportExcel={getReportFile}
          ></ExpandSearch>
        </Space>
      </div>
      <div className="container">
        <Table
          loading={loading}
          columns={detailReportAllColums}
          dataSource={data}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            total: total,
            onChange: onChangePagination,
            current: params.pages,
            pageSize: params.limit,
          }}
          bordered
          scroll={{ x: 1500 }}
        />
      </div>
    </div>
  );
};

export default DetailReport;
